import { formatSingleItemFeedToBE } from '../../../AdFacebookCreate/AdFacebookCreateForm/formatters/formatAdCreativeToBE/formatSingleImageOrVideoToBE/formatSingleItemToBE/formatSingleItemFeedToBE'

import { AD_FORMAT } from '../../../../../../constants/ads'
import { AD_TEXT, CALL_TO_ACTION, PRIMARY_TEXT_LIST } from '../../../fields'

export function getCreative(values, originalAd, adFormat) {
  const facebookPageId = originalAd.creative.object_story_spec?.page_id

  switch (adFormat) {
    case AD_FORMAT.carousel:
      return {
        object_story_spec: {
          link_data: {
            message: values[PRIMARY_TEXT_LIST]?.[0].text
          }
        }
      }
    case AD_FORMAT.single:
      const singleValues = {
        ...values,
        [AD_TEXT]: values[PRIMARY_TEXT_LIST]?.[0].text
      }

      return {
        object_story_spec: {
          ...formatSingleItemFeedToBE(singleValues)
        }
      }
    case AD_FORMAT.singleCustom:
    default:
      return {
        object_story_spec: {
          page_id: facebookPageId
        },
        asset_feed_spec: {
          bodies: values[PRIMARY_TEXT_LIST].map(item => {
            return {
              adlabels: [
                {
                  name: 'label_other_primarytext'
                },
                {
                  name: 'label_story_primarytext'
                }
              ],
              text: item.text
            }
          }),
          call_to_action_types: [values[CALL_TO_ACTION].toLowerCase()]
        }
      }
  }
}
